import { action } from 'typesafe-actions';

import { IKnmAttachment, IKnmAttachmentDownload } from 'APIPackage/KnmModule/interfaces/IKnmAttachment';
import { IKnmPlanInfo } from 'APIPackage/PlanListModule/interfaces/IKnmPlanInfo';
import { IKnmPlan } from 'PlanListPackage/MainModule/interfaces/IKnmPlan';
import { ExportFormatsEnum } from 'APIPackage/ImportExportModule/enums/ExportFormatsEnum';
import { IPlanStatusUpdate } from 'APIPackage/PlanListModule/interfaces/IPlanStatusUpdate';
import { IConsiderPlan } from 'APIPackage/PlanListModule/interfaces/IConsiderPlan';
import { PlanStatusEnum } from 'APIPackage/PlanListModule/enums/PlanStatusEnum';
import { ISelectOption } from 'UIPackage/MainModule/components/SelectInput';
import { IKnmHistoryItem } from 'APIPackage/KnmModule/interfaces/IKnmHistoryItem';
import { IKnmHistoryItemChanges } from 'KnmPackage/KnmHistoriesModule/interfaces/IKnmHistoryItemChanges';
import { IValidatedUnsignedKnmError } from 'APIPackage/KnmModule/interfaces/IValidatedUnsignedKnmByPlan';

import { PlanActionsEnum } from '../enums/PlanActionsEnum';
import { ISupervisionType } from '../../../APIPackage/DictionariesModule/interfaces/ISupervisionType';
import { IPlanForm, IPlanFormValues } from '../interfaces/PlanForm';
import { IPlanFormRef } from '../interfaces/IPlanFormRef';

export const planInitPage = (id: string) => action(PlanActionsEnum.PLAN_INIT_PAGE, { id });
export const planUpdate = (
  id: string,
  plan: Partial<IKnmPlan> & {
    ervkProsecutorOrgUuid: string;
    ervkProsecutorOrgVersionUuid: string;
    prosecutorOrgName: string;
  },
  cb: () => void,
) => action(PlanActionsEnum.PLAN_UPDATE, { id, plan, cb });
export const planSetInitialFormValues = (initialFormValues: IPlanForm) =>
  action(PlanActionsEnum.PLAN_SET_INITIAL_FORM_VALUES, { initialFormValues });
export const planSetLoadingDocuments = (value: boolean) =>
  action(PlanActionsEnum.PLAN_SET_LOADING_DOCUMENTS, { value });
export const planSetLoadingHistory = (value: boolean) => action(PlanActionsEnum.PLAN_SET_LOADING_HISTORY, { value });
export const planSetInfo = (planInfo: IKnmPlanInfo) => action(PlanActionsEnum.PLAN_SET_INFO, { planInfo });
export const planSetSupervisionTypeErknm = (supervisionTypeValue: ISupervisionType | undefined) =>
  action(PlanActionsEnum.PLAN_SET_SUPERVISION_TYPE_VALUE, { supervisionTypeValue });
export const planSetPlan = (plan: IKnmPlan) => action(PlanActionsEnum.PLAN_SET_PLAN, { plan });
export const planGetPlanDocuments = (id: string) => action(PlanActionsEnum.PLAN_GET_PLAN_DOCUMENTS, { id });
export const planSetPlanDocuments = (documents: IKnmAttachmentDownload[]) =>
  action(PlanActionsEnum.PLAN_SET_PLAN_DOCUMENTS, { documents });
export const planGetPlanHistory = (id: string) => action(PlanActionsEnum.PLAN_GET_PLAN_HISTORY, { id });
export const planSetPlanHistory = (history: IKnmHistoryItem[]) =>
  action(PlanActionsEnum.PLAN_SET_PLAN_HISTORY, { history });
export const planSetPlanHistoryChanges = (historyChanges: IKnmHistoryItemChanges[]) =>
  action(PlanActionsEnum.PLAN_SET_PLAN_HISTORY_CHANGES, { historyChanges });
export const planDownloadDocumentAttachment = (attachment: IKnmAttachmentDownload) =>
  action(PlanActionsEnum.PLAN_DOWNLOAD_DOCUMENT_ATTACHMENT, { attachment });
export const planExportPlanById = (format: ExportFormatsEnum, id: number, isApproved = false, isConsidered = false) =>
  action(PlanActionsEnum.PLAN_EXPORT_PLAN_BY_ID, { format, id, isApproved, isConsidered });
export const planUpdatePlanStatus = (id: number, status: PlanStatusEnum) =>
  action(PlanActionsEnum.PLAN_UPDATE_PLAN_STATUS, { id, status });
export const planUpdateErknmPlanStatus = (id: number, data: IPlanStatusUpdate, knmAmount: number) =>
  action(PlanActionsEnum.PLAN_UPDATE_ERKNM_PLAN_STATUS, { id, data, knmAmount });
export const planUpdatePlanStatusToConsider = (id: number, data: IConsiderPlan) =>
  action(PlanActionsEnum.PLAN_UPDATE_PLAN_STATUS_TO_CONSIDER, { id, data });
export const planSignPlanById = (
  planId: number,
  certificate: string,
  errors: IValidatedUnsignedKnmError[],
  form: IPlanFormValues,
) => action(PlanActionsEnum.PLAN_SIGN_PLAN_BY_ID, { planId, certificate, errors, form });
export const planSignTestPlanById = (planId: number) => action(PlanActionsEnum.PLAN_SIGN_TEST_PLAN_BY_ID, { planId });
export const planSignUpload = (planId: number, document: File, sign: File, form?: IPlanFormValues) =>
  action(PlanActionsEnum.PLAN_SIGN_UPLOAD, { planId, document, sign, form });
export const planChangeKno = (planId: number, knoValue: ISelectOption, document: IKnmAttachment) =>
  action(PlanActionsEnum.PLAN_CHANGE_KNO, { planId, knoValue, document });
export const planCheckIsPrivilegesKno = (ogrn: string) =>
  action(PlanActionsEnum.PLAN_CHECK_IS_PRIVILEGES_KNO, { ogrn });
export const planSetIsPrivilegesKno = (isPrivilegesKno: boolean) =>
  action(PlanActionsEnum.PLAN_SET_IS_PRIVILEGES_KNO, { isPrivilegesKno });
export const planSetFormRef = (formRef: IPlanFormRef) => action(PlanActionsEnum.PLAN_SET_FORM_REF, { formRef });
export const planExportXmlForSign = (id: number) => action(PlanActionsEnum.PLAN_EXPORT_XML_FOR_SIGN, { id });
